<template>
  <div>
    <template v-if="loaded">
      <div
        v-for="transaction in transactions"
        :key="transaction.field"
        class="entity-details-card mb-3 px-0 py-1"
      >
        <section class="section p-2">
          <BnplTransactionsRow
            :deal="deal"
            :transaction="transaction"
          ></BnplTransactionsRow>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import BnplTransactionsRow from "@/components/deal/BnplTransactionRow.vue";

export default {
  name: "BnplTransactionsTile",
  components: { BnplTransactionsRow },
  props: {
    transactions: {
      type: Array,
      required: true,
    },
    deal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
    };
  },
  async created() {
    this.loaded = true;
  },
};
</script>
